<div class="rounded p-2 flex flex-row items-center justify-between bg-stone-100">
  <div class="flex flex-row items-center justify-start space-x-2 min-w-0">
    <span class="px-2 py-1 bg-white rounded shadow-md flex-shrink-0"><i class="fa-solid fa-file"></i></span>
    <p class="truncate" title="{{originalName}}">{{originalName | friendlyFilename:30:17:10}}</p>
  </div>
  @if(creation()) {
  <button type="button" class="px-2 py-1 bg-white rounded shadow-md" (click)="removeFile(filename())">
    <i class="fa-solid fa-trash"></i>
  </button>
  }
  @if(splitted()) {
  <button type="button" (click)="downloadSource(filename())" [disabled]="isLoading()"
    class="px-2 py-1 bg-white rounded shadow-md" [class]="isLoading() ? 'cursor-not-allowed' : 'cursor-pointer'">
    @if (isLoading()) {
    <svg aria-hidden="true" class="w-4 h-4 primary fill-secondary animate-spin" viewBox="0 0 100 101" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor" />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill" />
    </svg>
    } @else {
    <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 7.28595 2
                4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2
                20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355
                20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447
                20.5355C2 19.0711 2 16.714 2 12ZM12 6.25C12.4142 6.25 12.75 6.58579
                12.75 7V12.1893L14.4697 10.4697C14.7626 10.1768 15.2374 10.1768 15.5303
                10.4697C15.8232 10.7626 15.8232 11.2374 15.5303 11.5303L12.5303
                14.5303C12.3897 14.671 12.1989 14.75 12 14.75C11.8011 14.75 11.6103
                14.671 11.4697 14.5303L8.46967 11.5303C8.17678 11.2374 8.17678 10.7626
                8.46967 10.4697C8.76256 10.1768 9.23744 10.1768 9.53033 10.4697L11.25
                12.1893V7C11.25 6.58579 11.5858 6.25 12 6.25ZM8 16.25C7.58579 16.25 7.25
                16.5858 7.25 17C7.25 17.4142 7.58579 17.75 8 17.75H16C16.4142 17.75
                16.75 17.4142 16.75 17C16.75 16.5858 16.4142 16.25 16 16.25H8Z" [attr.fill]="'#41220c'" />
    </svg>
    }
  </button>
  }
</div>
